import { dataTableFunctions } from "./datatable_functions";
import { toggleClass } from "../utils/misc";
import { setNumberOfPages } from "../back_office/datatables/utils";

const DEFAULT_SCROLL_SIZE = 143;
const DEFAULT_DISPLAY_LENGTH = 25;
export const DEFAULT_PAGINATION_CONFIG = {
  first: "",
  last: "",
  next: "",
  previous: "",
};

const initDatatable = (options) => {
  const customSearch = "search" in options;
  const useDefaultLength = !!options.defaultLength;
  const table = $(options.datatableElement).dataTable({
    processing: true,
    serverSide: true,
    autoWidth: false,
    lengthChange: useDefaultLength,
    lengthMenu: [25, 50, 100],
    language: {
      search: customSearch ? options.search.html : null,
      searchPlaceholder: customSearch ? options.search.placeholder : null,
      info: "_START_ - _END_ sur _TOTAL_",
      infoEmpty: "",
      infoFiltered: "",
      emptyTable: "Aucune donnée disponible",
      zeroRecords: "Aucune donnée disponible pour ces critères de recherche",
      processing: "<div id='datatables-processing'><img><p>Chargement en cours</p></div>",
      paginate: DEFAULT_PAGINATION_CONFIG,
      lengthMenu: "Lignes par page _MENU_",
    },
    ajax: {
      url: options.datatableElement.dataset.source,
      data: function (d) {
        if ("setRequestData" in options) {
          options.setRequestData(d);
        }
      },
    },
    searching: customSearch,
    order: options.orderColumns,
    scrollY: "scrollY" in options ? options.scrollY : DEFAULT_SCROLL_SIZE,
    iDisplayLength: DEFAULT_DISPLAY_LENGTH,
    columns: options.columns,
    createdRow: function (row, data) {
      $(row).attr({
        class: `item-row row-${data.id}`,
        "data-datatables-target": "row",
        "data-action": "click->datatables#handleRowSelection",
        "data-id": data.id,
      });

      if ("onCreatedRow" in options) {
        options.onCreatedRow(row, data);
      }
    },
    initComplete: () => {
      const { id } = options.datatableElement;
      initNumberOfItemsSelection(id);
      if ("onComplete" in options) {
        options.onComplete();
      }
      initDatatableCustomEvents(id);
    },
    drawCallback: function () {
      if (dataTableFunctions().datatablesController()) {
        dataTableFunctions().datatablesController().keepSelectedRowsOnTableReload();
      }
      if (options.displayNumberOfPages) {
        setNumberOfPages(table);
      }
      if ("onDraw" in options) {
        options.onDraw(table);
      }
    },
  });

  $(options.datatableElement).on("processing.dt", function (e, settings, processing) {
    toggleClass(e.target.parentElement, "datatables-wrapper-processing", !processing);
  });

  return table;
};

const initNumberOfItemsSelection = (datatableId) => {
  const numberOfItemsSelectionInputs = ["25-results", "50-results", "100-results"];
  const event = "change";
  numberOfItemsSelectionInputs.forEach((input) => dataTableFunctions().manageInputChange(input, datatableId, event));
};

const initDatatableCustomEvents = (datatableId) => {
  document.addEventListener("datatable:reloadRows", (event) => {
    dataTableFunctions().reloadRows(datatableId, event.detail);
  });
};

export { initDatatable };
